/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const AnchorFragment = {
  Anchor: gql`
    fragment AnchorQuery on anchor_Entry {
      anchorName
      anchortip
      typeHandle
    }
  `,
};
